import * as React from "react";
import {Component} from "react";

export class SyncConfigurationsHeader extends Component {
    render() {
        return (
            <header className="section-header">
                <h1 className="section-title">Exportación de datos</h1>
            </header>
        );
    }
}